import { render, staticRenderFns } from "./PanoramaHeaderItem.vue?vue&type=template&id=16bdb990&scoped=true"
import script from "./PanoramaHeaderItem.vue?vue&type=script&lang=js"
export * from "./PanoramaHeaderItem.vue?vue&type=script&lang=js"
import style0 from "./PanoramaHeaderItem.vue?vue&type=style&index=0&id=16bdb990&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bdb990",
  null
  
)

export default component.exports